<template>
    <el-dialog class="sliderVerify" :close-on-click-modal="false" title="拖动下方滑块完成拼图" width="384px"
        :visible.sync="isShowDialog" :before-close="closeDialog">
        <div class="slide-verify" :style="{ width: canvasWidth + 'px' }" onselectstart="return false;">
            <!-- 图片加载遮蔽罩 -->
            <div :class="{ 'img-loading': isLoading }" :style="{ height: canvasHeight + 'px' }" v-if="isLoading" />
            <!-- 认证成功后的文字提示 -->
            <div class="success-hint" :style="{ height: canvasHeight + 'px' }" v-if="verifySuccess">{{ successHint }}</div>
            <!--刷新按钮-->
            <div class="refresh-icon" @click="refresh('success')" />
            <!--前端生成-->
            <template v-if="isFrontCheck">
                <!--验证图片-->
                <canvas ref="canvas" class="slide-canvas" :width="canvasWidth" :height="canvasHeight" />
                <!--阻塞块-->
                <canvas ref="block" class="slide-block" :width="canvasWidth" :height="canvasHeight" />
            </template>
            <!--后端生成-->
            <template v-else>
                <!--验证图片-->
                <img ref="canvas" class="slide-canvas" :width="canvasWidth" :height="canvasHeight" />
                <!--阻塞块-->
                <img ref="block" :class="['slide-block', { 'verify-fail': verifyFail }]" />
            </template>
            <!-- 滑动条 -->
            <div class="slider"
                :class="{ 'verify-active': verifyActive, 'verify-success': verifySuccess, 'verify-fail': verifyFail }">
                <!--滑块-->
                <div class="slider-box" :style="{ width: sliderBoxWidth }">
                    <!-- 按钮 -->
                    <div class="slider-button" id="slider-button" :style="{ left: sliderButtonLeft }">
                        <!-- 按钮图标 -->
                        <div class="slider-button-icon" />
                    </div>
                </div>
                <!--滑动条提示文字-->
                <span class="slider-hint">{{ sliderHint }}</span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
function sum(x, y) {
    return x + y;
}

function square(x) {
    return x * x;
}

import { createCaptcha, validCaptcha } from "@/../api";
import { Loading } from 'element-ui';
import { mapState, mapMutations } from "vuex";
export default {
    name: 'sliderVerify',
    props: {
        // 阻塞块长度
        blockLength: {
            type: Number,
            default: 42,
        },
        // 阻塞块弧度
        blockRadius: {
            type: Number,
            default: 10,
        },
        // 画布宽度
        canvasWidth: {
            type: Number,
            default: 320,
        },
        // 画布高度
        canvasHeight: {
            type: Number,
            default: 155,
        },
        // 滑块操作提示
        sliderHint: {
            type: String,
            default: '向右滑动',
        },
        // 可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5，若为 -1 则不进行机器判断
        accuracy: {
            type: Number,
            default: 3,
        },
        // 图片资源数组
        imageList: {
            type: Array,
            default: () => [],
        },


    },
    data() {
        return {
            // 前端校验
            isFrontCheck: false,
            // 校验进行状态
            verifyActive: false,
            // 校验成功状态
            verifySuccess: false,
            // 校验失败状态
            verifyFail: false,
            // 阻塞块对象
            blockObj: null,
            // 图片画布对象
            canvasCtx: null,
            // 阻塞块画布对象
            blockCtx: null,
            // 阻塞块宽度
            blockWidth: this.blockLength * 2,
            // 阻塞块的横轴坐标
            blockX: undefined,
            // 阻塞块的纵轴坐标
            blockY: undefined,
            // 图片对象
            image: undefined,
            // 移动的X轴坐标
            originX: undefined,
            // 移动的Y轴做坐标
            originY: undefined,
            // 拖动距离数组
            dragDistanceList: [],
            // 滑块箱拖动宽度
            sliderBoxWidth: 0,
            // 滑块按钮距离左侧起点位置
            sliderButtonLeft: 0,
            // 鼠标按下状态
            isMouseDown: false,
            // 图片加载提示，防止图片没加载完就开始验证
            isLoading: true,
            // 时间戳，计算滑动时长
            timestamp: null,
            // 成功提示
            successHint: '',
            // 随机字符串
            nonceStr: undefined,
            //滑动次数
            numberSlides: 0,
            //显示对话框
            isShowDialog: false,
        };
    },
    mounted() {
        // this.init();
    },
    computed: {
        ...mapState(["isShowSliderVerify"]),
    },
    watch: {
        'isShowSliderVerify': {
            handler(val) {
                if (val) {
                    this.init();
                }
            },
            deep: true,

        }
    },
    methods: {
        ...mapMutations(["sliderResultHandle", "isShowSliderVerifyHandle"]),
        closeDialog() {
            this.isShowDialog = false
            this.$message.warning('安全验证已取消')
            this.isShowSliderVerifyHandle(false)
            this.$emit('closeDialog')
        },
        /* 初始化*/
        init() {
            this.initDom();

        },
        /* 初始化DOM对象*/
        initDom() {

            if (this.isFrontCheck) {
                this.blockObj = this.$refs.block;
                this.canvasCtx = this.$refs.canvas.getContext('2d');
                this.blockCtx = this.blockObj.getContext('2d');
                this.initImage();
            } else {
                this.getCaptcha();
            }
        },
        /* 后台获取验证图片*/
        getCaptcha(type) {
            let loadingInstance = null
            if (!(type == 'refresh')) {
                loadingInstance = Loading.service({ fullscreen: true });
            }
            let self = this;
            //取后端默认值
            const data = {
                stuAccount: localStorage.getItem('currUserPhone') || undefined
            };
            createCaptcha(data).then((response) => {
                if(response.data.code != 200){
                    this.$message.error(response.data.desc)
                    this.isShowSliderVerifyHandle(false)
                    return
                }
                if (!(type == 'refresh')) {
                    loadingInstance.close()
                }
                self.isShowDialog = true
                self.$nextTick(() => {
                    self.bindEvents();
                    self.numberSlides = 0
                    const data = response.data.data;
                    self.nonceStr = data.nonceStr;

                    self.$refs.block.src = data.blockSrc;
                    self.$refs.block.style.top = data.blockY + 'px';
                    self.$refs.canvas.src = data.canvasSrc;
                    self.blockObj = self.$refs.block;
                })
                //  loading.close();
            }).finally(() => {
                if (!(type == 'refresh')) {
                    loadingInstance.close()
                }
                self.isLoading = false;
                //  loading.close();
            });
        },
        /* 前端获取验证码*/
        initImage() {
            const image = this.createImage(() => {
                this.drawBlock();
                let { canvasWidth, canvasHeight, blockX, blockY, blockRadius, blockWidth } = this;
                this.canvasCtx.drawImage(image, 0, 0, canvasWidth, canvasHeight);
                this.blockCtx.drawImage(image, 0, 0, canvasWidth, canvasHeight);
                // 将抠图防止最左边位置
                let yAxle = blockY - blockRadius * 2;
                let ImageData = this.blockCtx.getImageData(blockX, yAxle, blockWidth, blockWidth);
                this.blockObj.width = blockWidth;
                this.blockCtx.putImageData(ImageData, 0, yAxle);
                // 图片加载完关闭遮蔽罩
                this.isLoading = false;
                // 前端校验设置特殊值
                this.nonceStr = 'loyer';
            });
            this.image = image;
        },
        /* 创建image对象*/
        createImage(onload) {
            const image = document.createElement('img');
            image.crossOrigin = 'Anonymous';
            image.onload = onload;
            image.onerror = () => {
                image.src = require('../../assets/login/teach-info-bg.png');
            };
            image.src = this.getImageSrc();
            return image;
        },
        /* 获取imgSrc*/
        getImageSrc() {
            const len = this.imageList.length;
            return len > 0 ? this.imageList[this.getNonceByRange(0, len)] : `https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png`;
        },
        /* 根据指定范围获取随机数*/
        getNonceByRange(start, end) {
            return Math.round(Math.random() * (end - start) + start);
        },
        /* 绘制阻塞块*/
        drawBlock() {
            this.blockX = this.getNonceByRange(this.blockWidth + 10, this.canvasWidth - (this.blockWidth + 10));
            this.blockY = this.getNonceByRange(10 + this.blockRadius * 2, this.canvasHeight - (this.blockWidth + 10));
            this.draw(this.canvasCtx, 'fill');
            this.draw(this.blockCtx, 'clip');
        },
        /* 绘制事件*/
        draw(ctx, operation) {
            const PI = Math.PI;
            let { blockX: x, blockY: y, blockLength: l, blockRadius: r } = this;
            // 绘制
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
            ctx.lineTo(x + l, y);
            ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
            ctx.lineTo(x + l, y + l);
            ctx.lineTo(x, y + l);
            ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
            ctx.lineTo(x, y);
            // 修饰
            ctx.lineWidth = 2;
            ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.9)';
            ctx.stroke();
            ctx[operation]();
            ctx.globalCompositeOperation = 'destination-over';
        },
        /* 事件绑定*/
        bindEvents() {
            // 监听鼠标按下事件
            document.getElementById('slider-button').addEventListener('mousedown', (event) => {
                this.startEvent(event.clientX, event.clientY);
            });
            // 监听鼠标移动事件
            document.addEventListener('mousemove', (event) => {
                this.moveEvent(event.clientX, event.clientY);
            });
            // 监听鼠标离开事件
            document.addEventListener('mouseup', (event) => {
                this.endEvent(event.clientX);
            });
            // 监听触摸开始事件
            document.getElementById('slider-button').addEventListener('touchstart', (event) => {
                this.startEvent(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
            });
            // 监听触摸滑动事件
            document.addEventListener('touchmove', (event) => {
                this.moveEvent(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
            });
            // 监听触摸离开事件
            document.addEventListener('touchend', (event) => {
                this.endEvent(event.changedTouches[0].pageX);
            });
        },
        /* 校验图片是否存在*/
        checkImgSrc() {
            if (this.isFrontCheck) {
                return true;
            }
            return !!this.$refs.canvas.src;
        },
        /* 滑动开始事件*/
        startEvent(originX, originY) {
            if (!this.checkImgSrc() || this.isLoading || this.verifySuccess) {
                return;
            }
            this.originX = originX;
            this.originY = originY;
            this.isMouseDown = true;
            this.timestamp = +new Date();
        },
        /* 滑动事件*/
        moveEvent(originX, originY) {
            if (!this.isMouseDown) {
                return false;
            }
            const moveX = originX - this.originX;
            const moveY = originY - this.originY;
            if (moveX < 0 || moveX + 40 >= this.canvasWidth) {
                return false;
            }
            this.sliderButtonLeft = moveX + 'px';
            let blockLeft = (this.canvasWidth - 40 - 20) / (this.canvasWidth - 40) * moveX;
            this.blockObj.style.left = blockLeft + 'px';
            this.verifyActive = true;
            this.sliderBoxWidth = moveX + 'px';
            this.dragDistanceList.push(moveY);
        },
        /* 滑动结束事件*/
        endEvent(originX) {
            if (!this.isMouseDown) {
                return false;
            }
            this.isMouseDown = false;
            if (originX === this.originX) {
                return false;
            }
            // 开始校验
            this.isLoading = true;
            // 校验结束
            this.verifyActive = false;
            // 滑动时长
            this.timestamp = +new Date() - this.timestamp;
            // 移动距离
            const moveLength = parseInt(this.blockObj.style.left);

            // 限制操作时长10S，超出判断失败
            if (this.timestamp > 10000) {
                this.verifyFailEvent();
            } else
                // 人为操作判定
                if (!this.turingTest()) {
                    this.verifyFailEvent();
                } else
                    // 是否前端校验(前端本地测试使用)
                    if (this.isFrontCheck) {
                        const accuracy = this.accuracy <= 1 ? 1 : this.accuracy > 10 ? 10 : this.accuracy; // 容错精度值
                        const spliced = Math.abs(moveLength - this.blockX) <= accuracy; // 判断是否重合
                        if (!spliced) {
                            this.verifyFailEvent();
                        } else {
                            // 设置特殊值，后台特殊处理，直接验证通过
                            this.isShowDialog = false
                            this.isShowSliderVerifyHandle(false)
                            this.sliderResultHandle(true)
                            this.$emit('success', { nonceStr: this.nonceStr, value: moveLength });
                        }
                    } else {
                        this.onSuccess({ nonceStr: this.nonceStr, blockX: moveLength })
                        // this.$emit('success', {nonceStr: this.nonceStr, blockX: moveLength});
                    }
        },
        /* 滑动验证结果*/
        onSuccess(captcha) {

            validCaptcha(captcha).then((response) => {

                let res = response.data

                if (res.code == 10000) {//验证码过期，刷新图片
                    this.refresh('success')
                    return
                }
                if (res.code != 200) {//接口异常
                    this.verifyFail = true;
                    this.$message.error(res.desc || '验证失败，请控制拼图对齐缺口')
                    this.sliderResultHandle(false)
                    this.refresh('fail');
                    return
                }

                if (!res.data) {//拼图校验失败
                    this.verifyFailEvent(res.desc);
                    return
                }
                this.verifySuccessEvent()
                this.numberSlides = 0
                setTimeout(() => {
                    this.refresh()
                    this.isShowDialog = false
                    this.isShowSliderVerifyHandle(false)
                    this.sliderResultHandle(res.data)
                    this.$emit('success')
                }, 1000)
            })
        },
        /* 图灵测试*/
        turingTest() {
            const arr = this.dragDistanceList; // 拖动距离数组
            if (arr.length > 0) {
                const average = arr.reduce(sum) / arr.length; // 平均值
                const deviations = arr.map((x) => x - average); // 偏离值
                const stdDev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // 标准偏差
                return average !== stdDev; // 判断是否人为操作
            } else {
                return false
            }

        },
        /* 校验成功*/
        verifySuccessEvent() {
            this.isLoading = false;
            this.verifySuccess = true;
            const elapsedTime = (this.timestamp / 1000).toFixed(1);
            if (elapsedTime < 1) {
                this.successHint = `仅仅${elapsedTime}S，你的速度快如闪电`;
            } else if (elapsedTime < 2) {
                this.successHint = `只用了${elapsedTime}S，这速度简直完美`;
            } else {
                this.successHint = `耗时${elapsedTime}S，争取下次再快一点`;
            }

        },
        /* 校验失败*/
        verifyFailEvent() {
            this.numberSlides++
            this.verifyFail = true;
            let msg = ''
            if (this.numberSlides < 3) {
                msg = "请拖动滑块将卡片对准缺口"
            } else {
                msg = '看来这个有点难，给你换一个试试'
            }
            this.$message.error(msg || '验证失败，请控制拼图对齐缺口')
            this.sliderResultHandle(false)
            this.$emit('fail', msg);
            this.refresh('fail');
        },
        /* 刷新图片验证码*/
        refresh(type) {
            // 延迟class的删除，等待动画结束
            setTimeout(() => {
                this.verifyFail = false;
            }, 500);
            this.isLoading = true;
            this.verifyActive = false;
            this.verifySuccess = false;
            this.blockObj.style.left = 0;
            this.sliderBoxWidth = 0;
            this.sliderButtonLeft = 0;
            if (this.isFrontCheck) {
                // 刷新画布
                let { canvasWidth, canvasHeight } = this;
                this.canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
                this.blockCtx.clearRect(0, 0, canvasWidth, canvasHeight);
                this.blockObj.width = canvasWidth;
                // 刷新图片
                this.image.src = this.getImageSrc();
            } else {
                if (type == "fail") {
                    if (this.numberSlides > 3) {
                        this.numberSlides = 1
                    }
                    if (this.numberSlides == 3) {//拼图拼错三次，才重新生成验证图片
                        this.getCaptcha('refresh');
                    } else {
                        this.isLoading = false;
                    }
                } else if (type == "success") {
                    this.getCaptcha('refresh');
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.slide-verify {
    position: relative;
}

.sliderVerify {
    ::v-deep {

        .el-dialog .el-dialog__headerbtn:focus .el-dialog__close,
        .el-dialog .el-dialog__headerbtn:hover .el-dialog__close {
            background-color: #fff;
        }

        .el-dialog {
            background: linear-gradient(180deg, #F0F5FF 0%, #FFFFFF 100%);
            border-radius: 6px;

            .el-dialog__title {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
            }

            .el-dialog__body {
                padding: 15px 20px 30px;
            }
        }
    }

}

/*图片加载样式*/
.img-loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 999;
    animation: loading 1.5s infinite;
    background-image: url(../../assets/sliderVerify-bg.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;

    border-radius: 5px;
}

@keyframes loading {
    0% {
        opacity: .7;
    }

    100% {
        opacity: 9;
    }
}

/*认证成功后的文字提示*/
.success-hint {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
    color: #2CD000;
    font-size: large;
}

/*刷新按钮*/
.refresh-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    background: url("../../assets/refresh.svg") 6px 6px no-repeat rgba(255, 255, 255, 0.4);
    background-size: 18px 18px;
    border-radius: 4px;
    z-index: 6;
    backdrop-filter: blur(10px);
}

/*验证图片*/
.slide-canvas {
    border-radius: 5px;
}

/*阻塞块*/
.slide-block {
    position: absolute;
    left: 0;
    top: 0;
}

/*校验失败时的阻塞块样式*/
.slide-block.verify-fail {
    transition: left 0.5s linear;
}

/*滑动条*/
.slider {
    position: relative;
    text-align: center;
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin-top: 6px;
    background: #F2F3F5;

    /* border: 1px solid #e4e7eb; */
    border-radius: 5px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4E5969;
}

/*滑动盒子*/
.slider-box {
    position: absolute;
    left: 0;
    top: 0;
    height: 40px;
    border: 0 solid #165DFF;
    background: #D1E9FE;
    border-radius: 5px;
}

/*滑动按钮*/
.slider-button {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: background .2s linear;
    border-radius: 5px;
}

/*鼠标悬浮时的按钮样式*/
.slider-button:hover {
    background: #165DFF
}

/*鼠标悬浮时的按钮图标样式*/
.slider-button:hover .slider-button-icon {
    background: url("../../assets/jiantou-hover.svg") 0 0 no-repeat;
    background-size: contain
}

/*滑动按钮图标*/
.slider-button-icon {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 20px;
    height: 20px;
    background: url("../../assets/jiantou.svg") 0 0 no-repeat;
    background-size: contain
}

/*校验时的按钮样式*/
.verify-active .slider-button {
    height: 40px;


}

/*校验时的滑动箱样式*/
.verify-active .slider-box {
    height: 40px;

}

/*校验成功时的滑动箱样式*/
.verify-success .slider-box {
    height: 40px;

    background-color: #E8FFEA;
}

/*校验成功时的按钮样式*/
.verify-success .slider-button {
    height: 40px;


    background-color: #00B42A !important;
}

/*校验成功时的按钮图标样式*/
.verify-success .slider-button-icon {
    background-position: 0 0 !important;
    background: url("../../assets/jiantou-hover.svg") 0 0 no-repeat;
    background-size: contain
}


/*校验失败时的滑动箱样式*/
.verify-fail .slider-box {
    height: 40px;
    border: 0 solid #f57a7a;
    background-color: #fce1e1;
    transition: width 0.5s linear;
}

/*校验失败时的按钮样式*/
.verify-fail .slider-button {
    height: 40px;

    border: 0;
    background-color: #F53F3F !important;
    transition: left 0.5s linear;
}

/*校验失败时的按钮图标样式*/
.verify-fail .slider-button-icon {
    background: url("../../assets/jiantou-hover.svg") 0 0 no-repeat;
    background-size: contain
}

/*校验状态下的提示文字隐藏*/
.verify-active .slider-hint,
.verify-success .slider-hint,
.verify-fail .slider-hint {
    display: none;
}
</style>

